module.exports = __webpack_public_path__ + "img/travel_boots_tinker.565e546a.png";